let backendHost;

const hostname = window && window.location && window.location.hostname;

if (
  hostname === 'admin.touress.com' ||
  hostname === 'www.admin.touress.com' ||
  hostname === 'touressadminprodv2.azurewebsites.net'
) {
  backendHost = 'https://api.touress.com/';
} else if (hostname === 'touressadminqav2.azurewebsites.net') {
  backendHost = 'https://touressapiqa.azurewebsites.net/';
} else if (hostname === 'touresswebqa.azurewebsites.net') {
  backendHost = 'https://touressapidev.azurewebsites.net/';
} else if (hostname === 'touressadminappsprodv2.azurewebsites.net') {
  backendHost = 'https://touress-api.azurewebsites.net/';
} else {
  // backendHost = 'https://touressapidev.azurewebsites.net/';
  backendHost = 'https://touressapiqa.azurewebsites.net/';
}

export const API_ROOT = `${backendHost}/Api`;
